import React, { useState, useEffect, useMemo } from "react";
import GenericList from "../components/GenericList";
import { Switch } from "@mui/material"; // Usando Material-UI para el switch
import {
  obtenerListaDeUsuarios,
  homologarUsuario,
  eliminarUsuario,
} from "../services/usuarios.service";
import { ACTION_BUTTONS, USERID } from "../config/constants";
import { Modal as ModalAntd } from "antd";
import Modal from "../components/Modal";
import PermisosList from "../components/PermisosList";
import UsuariosForm from "../components/UsuariosForm";
import { obtenerAccesosPorUsuario } from "../services/access.service";
import { getAllPermisos } from "../services/permisos.service";
import { COLORS } from "../config/theme";

const UserListPage = () => {
  const [usersList, setUsersList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [orderByField, setOrderByField] = useState("id_usuario");
  const [orderByDirection, setOrderByDirection] = useState("asc");
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalWidth, setModalWidth] = useState("750px");
  const [reload, setReload] = useState(false);
  const [reloadCount, setReloadCount] = useState(0);
  const [modalContent, setModalContent] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [permisos, setPermisos] = useState([]);
  const [permisoHomologar, setPermisoHomologar] = useState(false);
  const [permisoSeguridadAccesos, setPermisoSeguridadAccesos] = useState(false);
  const [permisoUsuAlta, setPermisoUsuAlta] = useState(false);

  const { confirm } = ModalAntd;
  const userID = localStorage.getItem(USERID);
  // Función para obtener los usuarios
  const fetchUsers = async () => {
    const usuariosList = await obtenerListaDeUsuarios(orderByField, orderByDirection);
    setUsersList(usuariosList.data);
  };

  useEffect(() => {
    fetchUsers();
  }, [currentPage, currentPageSize, orderByField, orderByDirection, reloadCount]);

  const handleSwitchChange = async (id, value) => {
    try {
      if (value) {
        confirm({
          title: (
            <div style={{ textAlign: "center" }}>Homologación de usuario</div>
          ),
          content: (
            <div style={{ textAlign: "center" }}>
              ¿Estás seguro de homologar al usuario?
            </div>
          ),
          okText: "Homologar",
          cancelText: "Cancelar",
          icon: null, // Puedes agregar un ícono personalizado o dejarlo vacío
          okType: "default", // Cambia el estilo del botón Ok
          okButtonProps: {
            style: { float: "left" }, // Mover el botón Ok a la izquierda
          },
          cancelButtonProps: {
            style: { float: "right" }, // Mover el botón Cancel a la derecha
          },
          onOk() {
            return homologarUsuario(id, value).then(() => {
              setReload(!reload);
            });
          },
        });
      } else {
        homologarUsuario(id, value).then(() => {
          setReload(!reload);
        });
      }
    } catch (error) {
      console.log("Error en homologación de usuario", error);
    }
  };

  const listColumns = [
    { title: "Nombre", field: "nombre" },
    { title: "Mail", field: "mail" },
    {
      title: "Tipo de Usuario",
      field: "id_tipo_us",
      render: (row) => {
        const typeLabels = { 1: "Profesional", 0: "Interno", 2: "Particular" };
        return typeLabels[row.id_tipo_us] || "Desconocido";
      },
      customFilterAndSearch: (term, row) => {
        const typeLabels = { 1: "Profesional", 0: "Interno", 2: "Particular" };
        const label = typeLabels[row.id_tipo_us] || "Desconocido";
        debugger;
        return label.toLowerCase().includes(term.toLowerCase());
      },
    },
    { title: "# Profesional", field: "nro_prof" },
    { title: "Teléfono", field: "ext_telefono" },
    { title: "Profesión", field: "ext_profesion" },
    { title: "Matrícula", field: "ext_matricula" },
    { title: "Domicilio", field: "ext_domicilio" },
    {
      title: "Homologado",
      field: "ext_homologado",
      render: (row) => {
        if (permisoHomologar) {
          return (
            <Switch
              checked={row.ext_homologado === "1"}
              onChange={(e) =>
                handleSwitchChange(row.id_usuario, e.target.checked ? 1 : 0)
              }
            />
          );
        } else {
          return (
            <span style={{ fontWeight: "bold", color: COLORS.CELESTE_CLARO }}>
              {row.ext_homologado === "1" ? "SI" : "NO"}
            </span>
          );
        }
      },
      customFilterAndSearch: (term, row) => {
        const estado = row.ext_homologado === "1" ? "SI" : "NO";
        return estado.toLowerCase().includes(term.toLowerCase());
      },
    },
  ];

  const listActionButtons = useMemo(() => [
    ACTION_BUTTONS.EDIT,
    ...(permisoSeguridadAccesos ? [ACTION_BUTTONS.SECURITY] : []),
    ACTION_BUTTONS.DELETE,
], [permisoSeguridadAccesos]);

  const onCreateAction = () => {
    setModalTitle(`ALTA DE USUARIO`);
    setModalContent(
      <UsuariosForm
        setIsVisibleModal={setIsVisibleModal}
        setReload={() => setReloadCount(prev => prev + 1)}
        usuarioExistente={null}
      />
    );
    setIsVisibleModal(true);
  };

  const onEditAction = (row) => {
    setModalTitle(
      <>
        EDICIÓN DE USUARIO{" "}
        <h3>
          <b>{row.nombre}</b>
        </h3>
      </>
    );
    console.log("Usuario", row);
    setSelectedUser(row);
    setModalContent(
      <UsuariosForm
        setIsVisibleModal={setIsVisibleModal}      
        setReload={() => setReloadCount(prev => prev + 1)}
        usuarioExistente={row}
      />
    );
    setModalWidth("900px");
    setIsVisibleModal(true);
  };

  const onDeleteAction = (row) => {
    confirm({
      title: <div style={{ textAlign: "center" }}>Eliminación de usuario</div>,
      content: (
        <div style={{ textAlign: "center" }}>
          ¿Estás seguro de eliminar el usuario?
        </div>
      ),
      okText: "Eliminar",
      cancelText: "Cancelar",
      icon: null, // Puedes agregar un ícono personalizado o dejarlo vacío
      okType: "default", // Cambia el estilo del botón Ok
      okButtonProps: {
        style: { float: "left" }, // Mover el botón Ok a la izquierda
      },
      cancelButtonProps: {
        style: { float: "right" }, // Mover el botón Cancel a la derecha
      },
      onOk() {
        return eliminarUsuario(row.id_usuario).then(() => {
          setReload(!reload);
        });
      },
    });
  };

  const onSecurityAction = (row) => {
    setModalTitle(
      <p>
        PERMISOS DE USUARIO <b>{row.nombre}</b>
      </p>
    );
    setModalContent(
      <PermisosList
        setIsVisibleModal={setIsVisibleModal}
        reload={reload}
        setReload={setReload}
        usuario={row}
      />
    );
    setIsVisibleModal(true);
  };

  const getListaPermisos = async () => {
    try {
      const permisosList = await getAllPermisos();
      if (permisosList.data.length > 0) {
        setPermisos(permisosList.data);
        getAccesosUsuario();
      } else {
        setPermisos([]);
      }
    } catch (error) {
      console.log("Failed to get permissions", error);
    }
  };

  useEffect(() => {
    getListaPermisos();
  }, [userID, reload]);

  const getAccesosUsuario = async () => {
    try {
      const accesosList = await obtenerAccesosPorUsuario(userID);
      // console.log("Accesos", accesosList);

      const homologate = accesosList?.data?.data.some(
        (accesos) => accesos.acceso === "USUHOM"
      );

      const permisoAccesos = accesosList?.data?.data.some(
        (accesos) => accesos.acceso === "USUACC"
      );

       const usuAlta = accesosList?.data?.data.some(
        (accesos) => accesos.acceso === "USUALT"
      );

      setPermisoHomologar(homologate);
      setPermisoSeguridadAccesos(permisoAccesos);
      setPermisoUsuAlta(usuAlta)
    } catch (error) {
      console.log("Failed to get access data", error);
    }
  };
  return (
    <>
      <GenericList
        columns={listColumns}
        data={usersList}
        addDisabled={!permisoUsuAlta}
        actions={listActionButtons}
        onCreateButtonClick={onCreateAction}
        onEditAction={onEditAction}
        onDeleteAction={onDeleteAction}
        onSecurityAction={onSecurityAction}
        title="Listado de Usuarios"
        onPageChange={(page) => {
          setCurrentPage(page + 1);
        }}
        onPageSizeChange={(pageSize) => {
          setCurrentPageSize(pageSize);
        }}
        onOrderChange={(order) => {
          debugger;
          setOrderByField(order[0]?.orderByField);
          setOrderByDirection(order[0]?.orderDirection);
          setReload(!reload);
        }}
      />
      <Modal
        title={modalTitle}
        open={isVisibleModal}
        setIsVisible={setIsVisibleModal}
        width={modalWidth}
      >
        {modalContent}
      </Modal>
    </>
  );
};

export default UserListPage;
